<template>
  <div class="flex items-start">
    <div class="flex-1">
      <div class="flex items-start">
        <div class="px-4">
          <p class="text-sm font-medium text-gray-900">
            {{ audience.name }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="flex-shrink-0">
      <div class="flex items-center space-x-2">
        <BaseButton primary outline small @click="handleRemove"> Remove </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    handleRemove() {
      this.$emit('remove', this.audience);
    },
  },
};
</script>
